<script>
	export default {
		name: 'UserExecuter',
		methods: {
			registerUserByUsername(username, password, fullName, email, phone, skipNewSystem, skipOldSystem) {
				const self_ = this;

				let uid_ = null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						const email_ = 'boid.dev.app+' + self_.appId + '-' + username + '@gmail.com';

						if(!skipNewSystem) {
							return self_.signUp(email_, password)	
						} else {
							return Promise.resolve()
						}
					}).then(result => {
						if(!skipNewSystem) {
							uid_ = result.uid;
							// custom bri life start
							const securityGroup_ = self_.getUserState('securityGroupCode')
							let securityGroupCode_ = null;
							let securityGroupName_ = null;
							if(securityGroup_ == 'admin') {
								securityGroupCode_ = 'user';
								securityGroupName_ = 'User';
							}
							if(securityGroup_ == 'adminibs') {
								securityGroupCode_ = 'ibs';
								securityGroupName_ = 'User IBS';
							}
							if(securityGroup_ == 'adminagency') {
								securityGroupCode_ = 'agency';
								securityGroupName_ = 'User Agency';
							}
							if(securityGroup_ == 'test') {
								securityGroupCode_ = 'test';
								securityGroupName_ = 'Test User';
							}
							return self_.$_userExec_registerUserIpCli(uid_, username, fullName, email, phone, null, null, null, null, 'all', 'All Users', securityGroupCode_, securityGroupName_, false, false, null)
							// custom bri life end
						} else {
							uid_ = 'qwerty';
							return Promise.resolve()
						}
					}).then(() => {
						if(!skipOldSystem) {
							return self_.$_userExec_registerUserIpc(username, uid_, email, phone, fullName)
						} else {
							return Promise.resolve()
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			registerUserByEmail(email, password, fullName, phone, skipNewSystem, skipOldSystem) {
				const self_ = this;

				let uid_ = null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						if(!skipNewSystem) {
							return self_.signUp(email, password)
						} else {
							return Promise.resolve()
						}
					}).then(result => {
						if(!skipNewSystem) {
							uid_ = result.uid;
							return self_.$_userExec_registerUserIpCli(uid_, email, fullName, email, phone, null, null, null, null, 'all', 'All Users', 'user', 'User', false, false, null)
						} else {
							uid_ = 'qwerty';
							return Promise.resolve()
						}
					}).then(() => {
						if(!skipOldSystem) {
							return self_.$_userExec_registerUserIpc(email, uid_, email, phone, fullName)
						} else {
							return Promise.resolve()
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			registerUserByPhone(phone, password, fullName, email, skipNewSystem, skipOldSystem) {
				const self_ = this;

				let uid_ = null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						const email_ = 'boid.dev.app+' + self_.appId + '-' + phone + '@gmail.com';
						const phoneNumber_ = '+628' + self_.username.substr(2);

						if(!skipNewSystem) {
							return self_.signUp(email_, password, phoneNumber_)
						} else {
							return Promise.resolve()
						}
					}).then(result => {
						if(!skipNewSystem) {
							uid_ = result.uid;
							return self_.$_userExec_registerUserIpCli(uid_, phone, fullName, email, phone, null, null, null, null, 'all', 'All Users', 'user', 'User', false, false, null)
						} else {
							uid_ = 'qwerty';
							return Promise.resolve()
						}
					}).then(() => {
						if(!skipOldSystem) {
							return self_.$_userExec_registerUserIpc(phone, uid_, email, phone, fullName)
						} else {
							return Promise.resolve()
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			getUserByUid(uid) {
				const self_ = this;

				let result_ = null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUsers({ uid: uid })
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							result_ = result[0]
						}
						resolve(result_)
					})
				})
			},
			getUserByUsername(username) {
				const self_ = this;

				let result_ = null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUsers({ username: username })
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							result_ = result[0]
						}
						resolve(result_)
					})
				})
			},
			updateUser(uid, body) { // body = { key: value, key: value, ... }
				const self_ = this;
				return self_.ipCliUpdateAppUsers(uid, body)
			},
			blockUser(uid) {
				const self_ = this;
				return self_.ipCliUpdateAppUsers(uid, { blocked: true })
			},
			unblockUser(uid) {
				const self_ = this;
				return self_.ipCliUpdateAppUsers(uid, { blocked: false })
			},
			disableUser(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						const body_ = { uid: uid }
						return self_.callFunction('authFunction', 'postDisable', { body: body_ })
					}).then(() => {
						return self_.ipCliUpdateAppUsers(uid, { disabled: true })
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			enableUser(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						const body_ = {
							uid: uid
						}
						return self_.callFunction('authFunction', 'postEnable', { body: body_ })
					}).then(() => {
						return self_.ipCliUpdateAppUsers(uid, { disabled: false })
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			deleteUser(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						const body_ = { uid: uid }
						return self_.callFunction('authFunction', 'postDelete', { body: body_ })
					}).then(() => {
						return self_.ipCliDeleteAppUsers(uid)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			getUserGroups(uid) {
				const self_ = this;
				return self_.ipCliGetAppUserGroups({ uid: uid })
			},
			allocateUserToGroup(uid, groupCode, groupName) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getUserGroups(uid)
					}).then(result => {
						if(self_.isEmpty(result)) {
							return self_.ipCliStoreAppUserGroups(uid, groupCode, groupName)
						} else {
							let allocated_ = false;

							result.forEach(row => {
								if(row['group_code'] == groupCode) {
									allocated_ = true;
								}
							})

							if(allocated_) { return Promise.resolve() }
							else {
								return self_.ipCliStoreAppUserGroups(uid, groupCode, groupName)
							}
						}
					}).then(result => {
						resolve(result)
					}).catch(error => {
						reject(error)
					})
				})
			},
			deallocateUserFromGroup(uid, groupCode) {
				const self_ = this;

				return self_.ipCliDeleteAppUserGroups(uid, groupCode)
			},
			getUserOptions(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserOptions({ uid: uid })
					}).then(result => {
						resolve(result[0])
					})
				}) 
			},
			updateUserOptions(uid, resetPassword, resetSecurityQuestion) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getUserOptions(uid)
					}).then(result => {
						if(self_.isEmpty(result)) {
							return self_.ipCliStoreAppUserOptions(uid, resetPassword, resetSecurityQuestion)
						} else {
							const body_ = {
								resetPassword: resetPassword,
								resetSecurityQuestion: resetSecurityQuestion
							}
							return self_.ipCliUpdateAppUserOptions(uid, body_)
						}
					}).then(result => {
						resolve(result)
					}).catch(error => {
						reject(error)
					})
				})
			},
			getUserChatData(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserChatData({ uid: uid })
					}).then(result => {
						resolve(result)
					})
				}) 
			},
			getUserPointData(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserPointData({ uid: uid })
					}).then(result => {
						resolve(result[0])
					})
				}) 
			},
			getUserTrainingData(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserTrainingData({ uid: uid })
					}).then(result => {
						resolve(result)
					})
				}) 
			},
			initializeUser(dataType) {
				const self_ = this;

				const uid_ = self_.getCurrentUser('uid')

				if(dataType == 'pointData') {
					return self_.$_userExec_initializeUserPointData(uid_)
				} else if(dataType == 'trainingData') {
					return self_.$_userExec_initializeUserTrainingData(uid_)
				} else {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.getUserByUid(uid_)
						}).then(result => {
							const user_ = result;

							self_.setUserState('id', user_['id'])
							self_.setUserState('oldSystemClientUserId', user_['old_system_client_user_id'])

							self_.setUserState('username', user_['username'])
							self_.setUserState('fullName', user_['full_name'])
							self_.setUserState('email', user_['email'])
							self_.setUserState('phone', user_['phone'])
							self_.setUserState('postcode', user_['postcode'])
							self_.setUserState('address1', user_['address1'])
							self_.setUserState('address2', user_['address2'])
							self_.setUserState('profilePictureUrl', user_['profile_picture_url'])
							self_.setUserState('userGroupCode', user_['user_group_code'])
							self_.setUserState('userGroupName', user_['user_group_name'])
							self_.setUserState('securityGroupCode', user_['security_group_code'])
							self_.setUserState('securityGroupName', user_['security_group_name'])
							self_.setUserState('blocked', user_['blocked'])
							self_.setUserState('disabled', user_['disabled'])

							self_.setUserState('isInitialized', true)

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}
			},
			$_userExec_registerUserIpCli(uid, username, fullName, email, phone, postcode, address1, address2, profilePictureUrl, userGroupCode, userGroupName, securityGroupCode, securityGroupName, blocked, disabled, oldSystemClientUserId) {
				const self_ = this;

				return self_.ipCliStoreAppUsers(uid, username, fullName, email, phone, postcode, address1, address2, profilePictureUrl, userGroupCode, userGroupName, securityGroupCode, securityGroupName, blocked, disabled, oldSystemClientUserId)
			},
			$_userExec_registerUserIpc(username, password, email, phone, fullName) {
				const self_ = this;

				return self_.ipcRegisterUser(username, password, email, phone, fullName)
			},
			$_userExec_initializeUserPointData(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getUserPointData(uid)
					}).then(result => {
						self_.setUserState('pointData', result)
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_userExec_initializeUserTrainingData(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getUserTrainingData(uid)
					}).then(result => {
						self_.setUserState('trainingData', result)
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			}
		}
	}
</script>